import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'phoneNo'
})

export class PhoneNoPipe implements PipeTransform {
  searchFlag = false;

  transform(number): any {
    if (number) {
      const newValue = number.split(',');
      let newArray;
      const arrayValue = [];
      for (let i = 0; i < newValue.length; i++) {
        newArray = this.getFilteredData(newValue[i]) + ' ';
        arrayValue.push(newArray);
      }

      return arrayValue.toString();
    }

  }

  getFilteredData(number) {
    if (number) {
      return number.replace(/\D+/g, '').replace(/([0-9]{3})([0-9]{3})([0-9]{4}$)/gi, '$1-$2-$3'); // mask numbers (xxx) xxx-xxxx
    } else {
      return '';
    }
  }
}
